import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './utils/route'
import store  from './utils/store'
import ElementUI from 'element-ui';
import BaiduMap from 'vue-baidu-map'
import VueAnimateNumber from 'vue-animate-number' 
import JsonViewer from 'vue-json-viewer'
import * as echarts from 'echarts'
import './components/component-Svgm/svgIcon.js';
import 'element-ui/lib/theme-chalk/index.css';
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

//引入组件
import Input from './components/component-block/block-input.vue'
import Paging from './components/component-block/block-paging.vue'
import SelectBlock from "./components/component-block/block-selectBtn.vue";
import SelectCheck from "./components/component-block/block-selectCheck.vue";
import IconBlock from './components/component-block/block-icon.vue'
import Treeselect from "@riophae/vue-treeselect";
import SvgIcon from './components/component-Svgm/svgIcon.vue'
import ShowBtns from './components/component-block/block-showBtn.vue'
import CopyBtn from './components/component-block/block-copyBtn.vue'
import ProvCty from './components/component-PcrIo/index.vue'
import ForRev from './components/component-block/block-selectForRev.vue'
import Qrcode from './components/component-block/block-qeCode.vue'
import Tablecommon from './components/component-Table/block-table.vue'
import InputBlock from './components/component-block/warp-input-block.vue'

//注册组件
Vue.component('InputBlock',Input)
Vue.component('Paging',Paging)
Vue.component('Treeselect',Treeselect)
Vue.component('SelectBlock',SelectBlock)
Vue.component('ForRev',ForRev)
Vue.component('SelectCheck',SelectCheck)
Vue.component('IconBlock',IconBlock)
Vue.component(SvgIcon.name, SvgIcon)
Vue.component('ProvCty', ProvCty)
Vue.component('ShowBtns', ShowBtns)
Vue.component('CopyBtn',CopyBtn)
Vue.component('Qrcode',Qrcode)
Vue.component('TableBlock',Tablecommon)
Vue.component('InputBlock',InputBlock)

Vue.use(BaiduMap,{
  ak:'BzuqzFjxCfadsXLFQxSCaGfOHjBtFhqf'
})

Vue.use(JsonViewer)

Vue.use(VueAnimateNumber)

Vue.use(ElementUI);
Vue.use(Vuex);
Vue.config.productionTip = false
Vue.prototype.$_echarts = echarts

//过滤器
Vue.filter('TutOutB',function(value){
  return  value.slice(0,value.indexOf('-'));
})

//清理两端的空格
Vue.filter('SpaceN',function(value){
  return  value.replace(/^\s*|\s*$/g,"");
})

// 格式化 金额
Vue.filter('moneyFromat',function(value){
  let suffixs = ['万','亿'];
  value = value+'';

  let str = '';

    let strSplit = "";

    if(value.indexOf('.') != -1){
     strSplit = value.substring(0,value.indexOf('.')).replaceAll(',','');
    }else{
      strSplit = value;
    }

    if(strSplit.length >= 5 && strSplit.length<= 8){
      // 万
      str = strSplit.substring(0,strSplit.length-4) +(strSplit.charAt(strSplit.length-4) == '0'?'':'.'+strSplit.charAt(strSplit.length-4)) + suffixs[0];
    }else if(strSplit.length>=9){
      // 亿
      str = strSplit.substring(0,strSplit.length-8) + (strSplit.charAt(strSplit.length-8) == '0'?'':'.'+strSplit.charAt(strSplit.length-8)) + suffixs[1];
    }else{
      str = value;
    }

  return str;
})
new Vue({
  render: h => h(App),
  router,
  store,
  beforeCreate(){
    Vue.prototype.$bus = this;
  }  
}).$mount('#app')
